import { FillButton } from '@wix/design-system';
import type { FC } from 'react';
import React, { useContext } from 'react';

import { RicosContext, ZIndexContext } from './../../../../../ricos-context';

import { ADD_CUSTOM_COLOR_BUTTON } from '../../data-hooks';

interface AddColorButtonProps {
  onAddClick: () => void;
  setRef?: (ref: HTMLDivElement) => void;
}

export const AddColorButton: FC<AddColorButtonProps> = ({ onAddClick, setRef }) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);

  return (
    <div ref={setRef}>
      <FillButton
        iconSize="medium"
        onClick={onAddClick}
        dataHook={ADD_CUSTOM_COLOR_BUTTON}
        tooltipContent={t('ColorPickerAddCustomColor_Tooltip')}
        tooltipProps={{
          appendTo: el => Boolean(el.getAttribute('data-hook')?.includes('ricos-portal')),
          zIndex: zIndexService.getZIndex('TOOLTIP'),
          moveBy: { y: 10 },
        }}
      />
    </div>
  );
};
